import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Formsy from 'formsy-react';

import * as Actions from '../actions/actions';

import WindowEventsHandler from '../services/WindowEventsHandler';

/* eslint no-unused-vars: 0 */
import Header from './Header';
import NavigationControl from './NavigationControl';
import PageInstruction from './PageInstruction';
import PageError from './PageError';

export class App extends Component {
    componentWillReceiveProps(nextProps) {
        if (this.props.location.pathname !== nextProps.location.pathname &&
            this.props.location.pathname.indexOf('match/1') === -1 &&
            this.props.location.pathname.indexOf('match/2') === -1) {
            /* Always scroll to top when route changes */
            WindowEventsHandler.scrollToTop();
            /* Adjust step navigation details when route changes */
            this.props.actions.navigate(nextProps.location.pathname);
        }
    }

    validateForm() {
        this.props.actions.validateForm();
    }

    invalidateForm() {
        this.props.actions.invalidateForm();
    }

    invalidSubmit() {
        this.props.actions.invalidSubmit();
    }

    validSubmit() {
        this.props.actions.validSubmit();
    }

    render() {
        const isHomePage = !this.props.location.pathname.split('/')[0];
        const isMatchPage = this.props.location.pathname === 'match';
        const classSuffix = isHomePage || isMatchPage ? '--full' : '';

        let adviceArea = null;
        if (this.props.person && this.props.person.get('adviceArea')) {
            adviceArea = this.props.person.get('adviceArea');
        }

        return (
            <div>
                <Header url={ this.props.location.pathname }/>

                <div className="app__main-section__container">
                    <section className={ `app__main-section${classSuffix}` }>
                        { !isHomePage ?
                            <PageInstruction stepIndex={ this.props.stepIndex } adviceArea={ adviceArea } />
                            : null }
                        { !isHomePage ? <PageError /> : null }
                        <Formsy.Form ref="form"
                                     onValid={ this.validateForm.bind(this) }
                                     onInvalid={ this.invalidateForm.bind(this) }
                                     onInvalidSubmit={ this.invalidSubmit.bind(this) }
                                     onValidSubmit={ this.validSubmit.bind(this) }
                                     className={ `app__main-section__form${classSuffix}` }>

                            { React.cloneElement(this.props.children) }

                            <NavigationControl />
                        </Formsy.Form>
                    </section>
                </div>
            </div>
        );
    }
}

App.propTypes = {
    invalidSubmit: React.PropTypes.bool,
    canSubmit: React.PropTypes.bool,

    stepIndex: React.PropTypes.number,
    title: React.PropTypes.string,

    actions: React.PropTypes.object,
    person: React.PropTypes.object,
};

function mapStateToProps(state) {
    return {
        person: state.reducer.get('person'),

        stepIndex: state.navigation.get('stepIndex'),
        title: state.navigation.get('title'),

        invalidSubmit: state.navigation.get('invalidSubmit'),
        canSubmit: state.navigation.get('canSubmit'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.jsx